/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-05-20 08:54:30
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-05-21 15:16:05
 * @FilePath: \website\src\components\mobile\attrs\cpt-select-option.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    attribute:{
        cptTableData:[
            {"name":"显示文本","value":"","namekey":"label"},
            {"name":"值","value":"","namekey":"value"},
        ],
        defaultValueType: null,
        defaultValue: [],
        multiple:false,
        // cascade: false,
        label:'移动端选项：', 
        labelBoolean:true,
        labelAlign:'right',
        labelWidth:100,
        placeholder:'请选择',
        size:'medium',
        width:144,
        height:32,
        align:"left",
        indent:0,
        bgColor:'#00000000',
        textColor:'#ffffff',
        textPlaceholderColor: '#333',
        fontStyle:'normal',
        fontWeight:'normal',
        fontFamily:'微软雅黑',
        fontSize:12,
        borderSize:1,
        borderColor:'#333333',
        borderRadius:0,
        lineType:'solid',
        required:false,
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#2684ff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
        showArrow:true,
        timeIcon:true,
        popupVisible:true,
        filterable:true,
        noQuery:false,
        optionBg: '#20263b',
        optionColor: '#fff',
        optionFontSize: 12,
        optionSelectedBg: 'hsla(0,0%,100%,.05)',
        optionSelectedColor: '#2c60db',
    },
    interaction:{multi:true,eventText:'切换选项时'},
    cptDataForm:{
        dataText: '{"value":"all","options":[{"label":"全部","value":"all","checkAll": "true"},{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}',
        apiUrl:'/select', sql:'select id from test limit 1',
        dataSource: 1, pollTime: -1,
        isCache: false,
    }
}